import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { signInOptionsQuery } from "../../lib/session.ts";
import { ProfileScreen } from "../../screens/settings/index.ts";

/** `/settings/profile`: the person's own name, language, time zone, appearance and sound, and how they sign in. */
export const Route = createFileRoute("/_app/settings/profile")({
  // how and where you're signed in is its own tab
  validateSearch: (search: Record<string, unknown>): { tab?: "signin" } =>
    search.tab === "signin" ? { tab: "signin" as const } : {},
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.prefetchQuery(actions.queryOptions("profile.get", {})),
      context.queryClient.prefetchQuery(actions.queryOptions("agents.listConnections", {})),
      context.queryClient.prefetchQuery(signInOptionsQuery),
      // how this person signs in, from the sign-in service: its client loads with the page, not with the app
      import("../../screens/settings/profile-auth.ts").then((auth) =>
        Promise.all([
          context.queryClient.prefetchQuery(auth.authSessionsQuery),
          context.queryClient.prefetchQuery(auth.authPasskeysQuery),
          context.queryClient.prefetchQuery(auth.authAccountsQuery),
        ]),
      ),
    ]),
  component: ProfileScreen,
});
